import { Results } from '@/pages/(guarded)/results/components/ResultsWrapper';
import { usePageContext } from '@/renderer/utils/usePageContext';

export default ArchivePage;

// Main component
function ArchivePage() {
  const {
    config: { title },
  } = usePageContext();

  return <Results userId="archive" baseUrl="/cfb-results" breakdown="cfb" title={title} />;
}
